import { z } from 'zod'
import { CourtesyStatus, RewardCategory } from '~library/enums'
import { suitCommoditySchema } from './suit-commodity'
import { usedCourtesyNameSchema } from './used-courtesy-name'

/**
 * 使用禮遇項目 Schema
 */
const usedCourtesySchema = z.object({
  ...usedCourtesyNameSchema.shape,
  /** 航段 */
  flightSegment: z.array(z.string()),
  /** 分類選項 */
  classType: z.enum(RewardCategory),
  /** 分類次選項 */
  classSecondType: z.string(),
  /** 分類第三選項 */
  classThirdType: z.string(),
  /** 狀態 */
  status: z.enum(CourtesyStatus),
  /** 券號 */
  couponNo: z.string(),
  /** EMD號碼 */
  emdNo: z.string(),
  /** 套裝商品 */
  suitCommodity: z.array(suitCommoditySchema)
})

/**
 * 取得行程之已使用禮遇項目 Response Schema
 */
export const getUsedCourtesyResponseSchema = z.object({
  /** 訂位代號 */
  pnr: z.string(),
  /** 航空公司 */
  airline: z.string(),
  /** 班機號碼 */
  flightNumber: z.string(),
  /** 機票號碼 */
  ticketNumber: z.string(),
  /** 航段 */
  flightSegment: z.array(z.string()),
  /** 出發日期 */
  departureTime: z.string(),
  /** 抵達日期 */
  arrivalTime: z.string(),
  /** 艙等 */
  rbd: z.string(),
  /** 排除行程 */
  excludeItinerary: z.boolean(),
  /** 使用禮遇項目 */
  usedCourtesy: z.array(usedCourtesySchema)
})

/**
 * 使用禮遇項目
 */
export interface UsedCourtesy extends z.infer<typeof usedCourtesySchema> {}

/**
 * 取得行程之已使用禮遇項目 Response
 */
export interface GetUsedCourtesyResponse
  extends z.infer<typeof getUsedCourtesyResponseSchema> {}
